import React, {useContext, useEffect, useState} from "react";
import {Avatar, Box, Button, ButtonGroup, Chip, FilledInput, FormControl, Grid, Link, Typography} from "@mui/material";

import arrowRight from "../../../assets/images/arrowRightStraight.svg";
import info from "../../../assets/images/info.svg";
import income from "../../../assets/images/income.svg";
import coin from "../../../assets/images/coin.svg";
import redeem from "../../../assets/images/redeem.svg";
import help from "../../../assets/images/help.svg";
import copy from "../../../assets/images/copy.svg";
import facebook from "../../../assets/images/facebook.svg";
import telegram from "../../../assets/images/telegram.svg";
import twitter from "../../../assets/images/twitter.svg";
import discord from "../../../assets/images/discord.svg";
import instagram from "../../../assets/images/instagram.svg";
import whatsapp from "../../../assets/images/whatsapp.svg";
import {useGetReferralLink, useRefData} from "../../../graphql/graphql/ref/hooks";
import {useVarAuth} from "../../../graphql/graphql/auth/defaults";
import QRLink from "./qr";
import ShareLinks from "./shareLinks";
import {CustomTooltip} from "../../../components/CustomTooltip";

const socialIcons = [
  {icon: facebook, href: "facebook.com/share?text"},
  {icon: telegram, href: "telegram.me/share/url?url"},
  {icon: twitter, href: "twitter.com/share?text"},
  {icon: discord, href: "discord.com/share?&text"},
  {icon: instagram, href: "api.instagram.com/send?&text"},
  {icon: whatsapp, href: "api.whatsapp.com/send?&text"},
];

const ReferralLink = () => {
  const [incomeCardData, setIncomeCardData] = useState([]);
  const {data} = useRefData();
  const {isLinkCopied, refLink, handleCopyLink} = useGetReferralLink();
  useEffect(() => {
    // const allSubscription = referralData.filter(
    //   (refData) => refData?.stripeSubscriptionId && refData?.planPrice
    // );
    // const totalPrice = allSubscription.length
    //   ? allSubscription
    //       .map((item) => item.planPrice)
    //       .reduce((prev, next) => prev + next)
    //   : 0;
    // ,
    if (data) {
      setIncomeCardData([
        {
          icon: income,
          title: "Monthly Payout",
          amt: data.sumOfCreditsToActiveReferral,
          chipLabel: `$${data.sumOfCreditsToActiveReferralInDollars.toLocaleString()} USD`,
        },
        {
          icon: redeem,
          info: "Credits are redeemable 30 days after they are earned. Meaning, if you earn 90 credits today, you can cash out $9.00 in 30 days.",
          title: "Redeemable",
          amt: data.redeemableCredits,
          chipLabel: `$${(data.redeemableCreditsInDollars || 0).toLocaleString()} USD`,
          href: {title: "Redeem", url: window.location.path},
        },
      ]);
    }
  }, [data]);

  return (
    <Box className="referralLinkMain">
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <Box className="leftPanelLink">
            <Box className="linkSect" display={{sm: "flex", xs: "block"}}>
              <QRLink />
              <Box className="linkDetail">
                <Typography variant="h6">Referral Link</Typography>
                <ButtonGroup variant="outlined" aria-label="outlined primary button group" sx={{width: "100%", my: 1}}>
                  <Button className="linkInput">
                    <FormControl variant="filled" sx={{width: "100%"}}>
                      <FilledInput
                        id="referralLink"
                        aria-describedby="filled-weight-helper-text"
                        readOnly
                        value={refLink}
                      />
                      <img src={help} alt="help" />
                    </FormControl>
                  </Button>
                  <CustomTooltip title={isLinkCopied ? "Copied to clipboard!" : "Copy to clipboard"}>
                    <Button className="btnCopy" onClick={handleCopyLink}>
                      <img src={copy} alt="copy" />
                      Copy
                    </Button>
                  </CustomTooltip>
                </ButtonGroup>
                <Typography>
                  Your friends get 20% OFF their first month when they use your link to register.
                </Typography>
                <ShareLinks />
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Box className="incomeCards" display="flex" alignItems="center">
            <Grid container spacing={{xs: 2, xl: 3}}>
              {incomeCardData.map((income, key) => (
                <Grid item xs={12} sm={6} key={key}>
                  <Box className="monthIncome">
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                      <Typography>{income.title}</Typography>
                      {!!income?.info && (
                        <CustomTooltip title={income.info}>
                          <img src={info} alt="info" />
                        </CustomTooltip>
                      )}
                    </Box>
                    <Box className="numbers">
                      <Typography variant="h5" display="flex" gap="5px">
                        {income.amt.toLocaleString()}
                        <sub>credits</sub>
                      </Typography>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h4">{income.chipLabel}</Typography>
                        {!!income?.href && (
                          <Link href={income.href.url} class="link">
                            {income.href.title} <img src={arrowRight} alt="arrowRight" />
                          </Link>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReferralLink;
